import React from "react";
import { useSelector } from "react-redux";
import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";

const infoFields = [
  {
    key: "fees",
    title: "Fees",
    suffix: "%",
  },
  {
    key: "management_fees",
    title: "Management Fees",
    suffix: "%",
  },
];

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    marginBottom: 50,
  },
  paper: {
    fontWeight: 400,
    color: COLORS.blackShade,
    marginTop: 8,
  },
  box: {
    display: "flex",
  },
  rightDiv: {
    "& .MuiGrid-justify-content-xs-center": {
      justifyContent: "flex-start",
    },
  },
  boldText: {
    fontSize: 30,
    fontWeight: 700,
  },
  boldData: {
    fontWeight: 600,
  },
  leftDiv: {
    "& .MuiGrid-spacing-xs-3": {
      width: 350,
    },
  },
  hr: {
    width: 545,
    marginTop: 50,
    marginBottom: 50,
    marginLeft: 0,
  },
  subHeading: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 20,
  },
  debtText: {
    fontWeight: 700,
    color: COLORS.blackShade,
    marginTop: 8,
  },
}));

const PowerRevenue = ({ data, onDataChange }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Box>
      <Typography className={classes.heading}>
        <span className={classes.boldText}>Tenancy data -</span> Power Revenues
      </Typography>
      <Typography className={classes.subHeading}>Power operating Expenses</Typography>
      {infoFields.map((value, i) => {
        return (
          <Grid container spacing={3} key={i} className={classes.leftDiv}>
            <Grid item xs>
              <Typography variant="h5" className={classes.paper}>
                {value.title}
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.rightDiv}>
              <Box width={600}>
                <TextInput
                  style={{ background: COLORS.white, width: "180px" }}
                  type="number"
                  value={data[value.key]}
                  onChange={(v) => onDataChange(value.key, v)}
                  containerStyle={classes.box}
                  suffix={value.suffix ? value.suffix : ""}
                />
              </Box>
            </Grid>
          </Grid>
        );
      })}
      <Grid container spacing={3} style={{ paddingBottom: 90 }}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Total Power Operating Expenses
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Typography variant="h5" className={classes.boldData}>
            {currencySymbol} XXX
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Net Operating Income (NOI)
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Typography variant="h5" className={classes.boldData}>
            {currencySymbol} XXX
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className={classes.leftDiv}>
        <Grid item xs>
          <Typography variant="h5" className={classes.debtText}>
            Debt Services
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Box width={600}>
            <TextInput
              style={{ background: COLORS.white, width: "180px" }}
              type="number"
              value={data.debt_service}
              onChange={(v) => onDataChange("debt_service", v)}
              containerStyle={classes.box}
              suffix={"%"}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3} style={{ paddingBottom: 150 }}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Cash Flow Before Taxes
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Typography variant="h5" className={classes.boldData}>
            {currencySymbol} XXX
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PowerRevenue;
